import http, { createApi } from '@core/fetch'
import { API_EDIT, API_SHOP_INFO, API_MAIN_EDIT } from '@constant'

export default {
  logout: createApi('/p/wedding/index.php/Admin/APIAuth/logout'),
  edit: createApi(API_EDIT),
  mainEdit: createApi(API_MAIN_EDIT),
  postEdit: createApi.post(API_EDIT, { ignore: ['', undefined] }),
  weddingWallQrcode: createApi(
    '/p/wedding/index.php/Home/WeixinWallNew/login_qrcode'
  ),
  checkWeddingWallLogin: createApi(
    '/p/wedding/index.php/Home/WeixinWallNew/checkLogin'
  ),
  shopInfo: createApi(API_SHOP_INFO),
  // 登录子店 step 1
  login_first: body =>
    http.post('/p/wedding/index.php/MainAdmin/APISubMerchant/sub_login', {
      body
    }),

  // 登录子店 step 2
  login_second: params => {
    return http(`/p/wedding/index.php/Admin/APIAuth/super_login?${params}`)
  },

  //获取图片安全地址
  getSafeImg: createApi('/p/wedding/Home/APIUtils/timestamp_antileech_url'),

  //短信验证码
  checkMsgCode: body =>
    http.put('/p/wedding/index.php/Admin/APIMerchantSupport/verifySafety', {
      body
    }),

  /**
   * 获取权限id
   */
  authList: createApi('/hms/hljMerchantCenter/appApi/authorize/auth/list'),

  merchantPermission: createApi(
    '/hms/hljMerchantCenter/appApi/user/merchantPermission'
  ),

  checkJkb: createApi(
    '/hms/merchantPolicy/appApi/merchant/policy/check/jkb'
  )
}
